import { createBrowserRouter, Navigate } from "react-router-dom"
import ProtectedRoute from "./components/auth/ProtectedRoute"
import TrainerRoute from "./components/auth/TrainerRoute"
import LoginPage from "./components/auth/LoginPage"
import ForgotPasswordPage from "./components/auth/ForgotPasswordPage"
import ResetPasswordPage from "./components/auth/ResetPasswordPage"
import ChangePasswordPage from "./components/auth/ChangePasswordPage"
import AppShell from "./components/layout/AppShell"
import TrainingTab from "./components/dashboard/TrainingTab"
import CrmTab from "./components/dashboard/CrmTab"
import FinancialGate from "./components/dashboard/FinancialGate"
import ExerciseLibraryTab from "./components/dashboard/ExerciseLibraryTab"
import RoutineGalleryTab from "./components/dashboard/RoutineGalleryTab"
import ClientProfilePage from "./components/dashboard/ClientProfilePage"
import TrainingDisplayPage from "./components/display/TrainingDisplayPage"
import ProgramEditor from "./components/programs/ProgramEditor"
import MemberDashboard from "./components/member/MemberDashboard"
import AppointmentsTab from "./components/dashboard/AppointmentsTab"
import AdminTab from "./components/dashboard/AdminTab"

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/signup", element: <Navigate to="/login" replace /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  {
    // Rutas accesibles para cualquier usuario autenticado
    element: <ProtectedRoute />,
    children: [
      { path: "/member", element: <MemberDashboard /> },
      { path: "/change-password", element: <ChangePasswordPage /> },
    ],
  },
  {
    // Rutas exclusivas para trainer y admin
    element: <TrainerRoute />,
    children: [
      { path: "/display", element: <TrainingDisplayPage /> },
      {
        path: "/dashboard",
        element: <AppShell />,
        children: [
          { index: true, element: <Navigate to="training" replace /> },
          { path: "training", element: <TrainingTab /> },
          { path: "crm", element: <CrmTab /> },
          { path: "financial", element: <FinancialGate /> },
          { path: "exercises", element: <ExerciseLibraryTab /> },
          { path: "routines", element: <RoutineGalleryTab /> },
          { path: "appointments", element: <AppointmentsTab /> },
          { path: "admin", element: <AdminTab /> },
          { path: "programs/:clientId", element: <ProgramEditor /> },
          { path: "clients/:clientId", element: <ClientProfilePage /> },
        ],
      },
    ],
  },
  { path: "*", element: <Navigate to="/login" replace /> },
])
